import { getQuarterlyReportStatusLabel } from './getQuarterlyReportStatusLabel'

interface Props {
  name: string
}

export const QuarterlyReportStatusLabel = ({ name }: Props) => <span>{getQuarterlyReportStatusLabel(name)}</span>
